module.exports = __webpack_public_path__ + "static/media/e912bac8.jpg";